"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FooterNav = _interopRequireDefault(require("./FooterNav"));
var _FooterSocialShare = _interopRequireDefault(require("./FooterSocialShare"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Footer = props => {
  if (!props.fields || !props.fields.NavSetting || !props.fields.NavSetting.fields) return null;
  var getURLQuery = new URLSearchParams(props.params.pageQuery);
  var navSetting = props.fields.NavSetting.fields;
  var showNav = getURLQuery.get('nav') === 'false' ? false : navSetting.ShowFooter.value;
  if (showNav) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, navSetting.ShowSocialShare.value && /*#__PURE__*/_react.default.createElement(_FooterSocialShare.default, props.params), /*#__PURE__*/_react.default.createElement(_FooterNav.default, {
      fields: props.fields,
      componentParams: props.componentParams,
      params: props.params
    }));
  } else {
    if (navSetting.ShowSocialShare.value) return /*#__PURE__*/_react.default.createElement(_FooterSocialShare.default, props.params);else return null;
  }
};
var _default = exports.default = Footer;